// src/contexts/AuthContext.tsx
import React, { createContext, useState, ReactNode, useContext, useEffect } from "react";

interface AuthContextType {
  loggedIn: boolean;
  token: string | null;
  login: (token: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [token, setToken] = useState<string | null>(null);

  // 检查本地存储中的 token
  useEffect(() => {
    const savedToken = localStorage.getItem('accessToken');
    if (savedToken) {
      setToken(savedToken);
      setLoggedIn(true);
    }
  }, []);

  const login = (newToken: string) => {
    setToken(newToken);
    setLoggedIn(true);
    localStorage.setItem('accessToken', newToken);
  };

  const logout = () => {
    setToken(null);
    setLoggedIn(false);
    localStorage.removeItem('accessToken');
  };

  return (
    <AuthContext.Provider value={{ loggedIn, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
